// extracted by mini-css-extract-plugin
export var errorsContainer = "_tx-1";
export var link = "_tx-0";